// V4.2.4: Error Boundary Component
import React, { Component } from 'react';
import { styles } from '../constants/styles';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log error to console
    console.error('❌ Error Boundary caught an error:', error, errorInfo);
    
    // V5.9: ChunkLoadError için özel handling
    if (error.name === 'ChunkLoadError' || (error.message && error.message.includes('Loading chunk'))) {
      console.warn('⚠️ ChunkLoadError tespit edildi - Cache temizleniyor ve sayfa yenileniyor...');
      
      // Service Worker cache'ini temizle
      if ('caches' in window) {
        caches.keys().then((cacheNames) => {
          cacheNames.forEach((cacheName) => {
            caches.delete(cacheName);
          });
          console.log('✅ Cache temizlendi');
        });
      }
      
      // Service Worker'ı unregister et
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.getRegistrations().then((registrations) => {
          registrations.forEach((registration) => {
            registration.unregister();
            console.log('✅ Service Worker unregister edildi');
          });
        });
      }
      
      // 2 saniye sonra hard refresh yap
      setTimeout(() => {
        window.location.reload(true);
      }, 2000);
      
      return; // Error state'e geçme, reload yapılacak
    }
    
    // Log to Firebase Crashlytics (if available)
    // TODO: Add Firebase Crashlytics integration
    
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
    // Reload page to reset state
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      // Custom fallback UI
      return (
        <div
          style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '40px',
            background: '#f7fafc'
          }}
        >
          <div
            style={{
              ...styles.card,
              maxWidth: '600px',
              textAlign: 'center'
            }}
          >
            <div style={{ fontSize: '64px', marginBottom: '20px' }}>⚠️</div>
            <h1 style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '10px', color: '#c53030' }}>
              Bir Hata Oluştu
            </h1>
            <p style={{ fontSize: '16px', color: '#4a5568', marginBottom: '20px' }}>
              Üzgünüz, beklenmeyen bir hata oluştu. Lütfen sayfayı yenileyin veya tekrar deneyin.
            </p>
            
            {process.env.NODE_ENV === 'development' && this.state.error && (
              <details
                style={{
                  marginTop: '20px',
                  padding: '15px',
                  background: '#fff5f5',
                  borderRadius: '8px',
                  textAlign: 'left',
                  fontSize: '12px',
                  color: '#742a2a',
                  maxHeight: '300px',
                  overflow: 'auto'
                }}
              >
                <summary style={{ cursor: 'pointer', fontWeight: 'bold', marginBottom: '10px' }}>
                  Hata Detayları (Sadece Geliştirme Modunda)
                </summary>
                <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                  {this.state.error.toString()}
                  {this.state.errorInfo && (
                    <>
                      {'\n\n'}
                      {this.state.errorInfo.componentStack}
                    </>
                  )}
                </pre>
              </details>
            )}

            <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', marginTop: '30px' }}>
              <button
                onClick={this.handleReset}
                style={{
                  ...styles.button,
                  background: 'linear-gradient(135deg, #284D3A 0%, #A26F29 100%)',
                  color: 'white',
                  padding: '12px 24px',
                  fontSize: '16px'
                }}
              >
                🔄 Sayfayı Yenile
              </button>
              <button
                onClick={() => {
                  // V5.9: Hard refresh yap (cache bypass)
                  window.location.reload(true);
                }}
                style={{
                  ...styles.button,
                  background: '#f6ad55',
                  color: 'white',
                  padding: '12px 24px',
                  fontSize: '16px'
                }}
              >
                🔄 Hard Refresh (Cache Temizle)
              </button>
              <button
                onClick={() => (window.location.href = '/')}
                style={{
                  ...styles.button,
                  background: '#e2e8f0',
                  color: '#4a5568',
                  padding: '12px 24px',
                  fontSize: '16px'
                }}
              >
                🏠 Ana Sayfaya Dön
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;

